// resources/js/stores/settingsStore.js
import { defineStore } from 'pinia'

export const useSettingsStore = defineStore('settings', {
  state: () => ({
    customPrimary: '#default-primary-color',
    customSecondary: '#default-secondary-color',
    isInitialized: false,
    isServer: typeof window === 'undefined',
  }),
  actions: {
    initializeSettings(settings) {
      if (settings && !this.isInitialized) {
        this.customPrimary = settings.custom_1 || this.customPrimary
        this.customSecondary = settings.custom_2 || this.customSecondary
        this.isInitialized = true
      }
      if (!this.isServer) {
        if (!this.isInitialized) {
          this.customPrimary = localStorage.getItem('customPrimary') || this.customPrimary
          this.customSecondary = localStorage.getItem('customSecondary') || this.customSecondary
        } else {
          localStorage.setItem('customPrimary', this.customPrimary)
          localStorage.setItem('customSecondary', this.customSecondary)
        }
        this.applyColors()
      }
    },
    applyColors() {
      if (!this.isServer) {
        document.documentElement.style.setProperty('--color-primary', this.customPrimary)
        document.documentElement.style.setProperty('--color-secondary', this.customSecondary)
      }
    },
  },
})
